export const nftRewardStyles = {
  root: "relative shrink-0",

  haloWrapper:
    "pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2",

  haloImage:
    "size-full mix-blend-screen brightness-110 saturate-150 motion-safe:animate-[spin_var(--nft-reward-halo-spin)_linear_infinite] motion-reduce:animate-none",

  image: "relative block size-full object-cover",

  badgeOverlay:
    "pointer-events-none absolute inset-x-0 bottom-2.5 z-10 flex justify-center",

  badgeContent: "pointer-events-auto",
} as const
